import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }

import { computed, ref } from 'vue';
import { MedKitNumberField } from '@bigpicturemedical/medkit';
import { useIncrementDate } from '@/composables/dates';
import { useI18n } from 'vue-i18n';
import { i18n } from '@/i18n/i18n';
import { IErrors, IOption } from '@/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitOfTimeInput',
  props: {
    unitOptions: { default: () => [
    {
      value: 'days',
      label: i18n.global.t('platform.common.date-time.days')
    },
    {
      value: 'weeks',
      label: i18n.global.t('platform.common.date-time.weeks')
    },
    {
      value: 'months',
      label: i18n.global.t('platform.common.date-time.months')
    }
  ] },
    unitPlaceholder: null,
    label: null,
    required: { type: Boolean },
    digit: { default: '' },
    unit: { default: '' },
    min: { default: 1 },
    error: { default: '' }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'change', data: { digit: number; unit: string; date: Date | string; }): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { unitOptions: IOption[], unitPlaceholder: string, label: string, required: boolean, digit: number | string, unit: string, min: number, error: IErrors };



const { t, d } = useI18n();
const unitOfTimeDigit = ref<number | string>(props.digit || '');
const unitOfTimeUnit = ref<string>(props.unit || '');

const validationError = computed(() => props.error || '');
const futureDate = computed(() => {
  if (!unitOfTimeDigit.value || !unitOfTimeUnit.value) {
    return '';
  }
  return useIncrementDate(unitOfTimeDigit.value, unitOfTimeUnit.value);
});



const handleChange = () => {
  validationError.value = '';
  emit('change', {
    digit: unitOfTimeDigit.value,
    unit: unitOfTimeUnit.value,
    date: futureDate.value ? futureDate.value.toISOString() : ''
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MedKitNumberField), {
      modelValue: unitOfTimeDigit.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((unitOfTimeDigit).value = $event)),
      unit: unitOfTimeUnit.value,
      "onUpdate:unit": _cache[1] || (_cache[1] = ($event: any) => ((unitOfTimeUnit).value = $event)),
      label: __props.label,
      "unit-options": __props.unitOptions,
      min: __props.min,
      "unit-placeholder": __props.unitPlaceholder,
      required: __props.required,
      error: _unref(validationError),
      class: "unit-of-time w-1/2",
      onChange: handleChange
    }, null, 8, ["modelValue", "unit", "label", "unit-options", "min", "unit-placeholder", "required", "error"]),
    (unitOfTimeDigit.value && unitOfTimeUnit.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["text-sm text-gray-600", { 'mt-8': !_unref(validationError) }])
        }, _toDisplayString(_unref(t)('custom.uhb.review.date-will-be', {
          date: _unref(d)(_unref(futureDate), 'shortMonth'),
        })), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})